module.exports = __webpack_public_path__ + "static/img/bg_1_mask.a155e353.png";